<template>
	<section class="usage-wallet-activity-table org-settings__plan-and-billing-table b9:w-1/2 b12:w-1/3">
		<div class="flex items-center justify-between mb-4">
			<h3 class="font-display">Wallet Activity</h3>
		</div>
		<div class="org-settings__plan-and-billing-table-container">
			<table class="table-style w-full">
				<thead>
					<tr>
						<th class="text-left whitespace-nowrap">Month</th>
						<th class="text-left whitespace-nowrap">Added</th>
						<th class="text-left whitespace-nowrap">Usage</th>
						<th class="text-right whitespace-nowrap">Ending Balance</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="!hasActivity">
						<td :colspan="4" class="text-subtle">
							No wallet activity to display.
						</td>
					</tr>
					<tr v-for="(row, index) in activity" v-else :key="row.MonthStart + '-' + index">
						<td class="font-medium">
							{{ formatMonth(row.MonthStart) }}
						</td>
						<td>
							<CToolTip
								v-if="row.Added !== null && row.Added !== undefined && row.AddedItems && row.AddedItems.length > 0"
								placement="top"
								:is-basic="false"
								:use-button="false"
								show-on-click
								is-interactive
							>
								<template #button>
									<span class="text-link hover:underline">{{ currency.format(row.Added) }}</span>
								</template>
								<div class="min-w-[180px] space-y-1 text-sm">
									<div v-for="(item, itemIndex) in row.AddedItems" :key="`${item.InvoiceId}-${item.Label}-${itemIndex}`" class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-4 gap-y-2">
										<span class="min-w-0">{{ item.Label }}</span>
										<a
											:href="`/${orgCode}/settings/invoice/${item.InvoiceId}`"
											target="_blank"
											class="text-link underline hover:text-[var(--link-hover)]"
										>
											{{ currency.format(item.Amount) }}
										</a>
									</div>
								</div>
							</CToolTip>
							<!-- No invoices -->
							<span v-else-if="row.Added !== null && row.Added !== undefined" class="text-primary">{{ currency.format(row.Added) }}</span>
							<span v-else class="text-subtle">—</span>
						</td>
						<td>
							<a
								v-if="row.Usage !== null && row.Usage !== undefined"
								href="#"
								class="text-link underline"
								@click.prevent="$emit('open-usage-details', getPreviousMonthStart(row.MonthStart))"
							>
								{{ formatUsage(row.Usage) }}
							</a>
							<span v-else class="text-subtle">—</span>
						</td>
						<td class="text-right">
							<span v-if="row.EndingUsageWalletBalance === null || row.EndingUsageWalletBalance === undefined" class="text-subtle">—</span>
							<span v-else class="text-primary">{{ currency.format(row.EndingUsageWalletBalance) }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</section>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import type { PropType } from 'vue';
	import type { UsageWalletActivityViewModel } from '@cognitoforms/types/server-types/services/view-models/usage-wallet-activity-view-model';
	import CToolTip from 'src/components/interaction/ToolTip.vue';

	export default defineComponent({
		name: 'CUsageWalletActivityTable',
		components: {
			CToolTip
		},
		props: {
			activity: { type: Array as PropType<UsageWalletActivityViewModel[]>, required: true },
			orgCode: { type: String, required: true }
		},
		emits: ['open-usage-details'],
		data() {
			return {
				currency: new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD'
				})
			};
		},
		computed: {
			hasActivity() {
				return this.activity && this.activity.length > 0;
			}
		},
		methods: {
			formatMonth(date: Date | string) {
				const d = new Date(date);
				const month = d.getUTCMonth() + 1;
				const year = d.getUTCFullYear();
				return `${month}/${year}`;
			},
			formatUsage(amount: number) {
				return this.currency.format(-Math.abs(amount));
			},
			getPreviousMonthStart(date: Date | string) {
				const d = new Date(date);
				return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 1, 1)).toISOString();
			}
		}
	});
</script>
